import { NewsList } from "@/@types";
import { NewsListResponse } from "../../news/models/NewsListResponse";

export function mapNewsList(response: NewsListResponse): NewsList {
    return {
        news: response.news.map(newsItem => ({
            title: newsItem.title,
            imageUrl: newsItem.image_url,
            mediaUrl: newsItem.media_url,
            date: newsItem.date,
            categoryName: newsItem.category_name,
            categorySlug: newsItem.category_slug,
            slug: newsItem.slug,
        })),
        pagination: {
            currentPage: response.pagination.current_page,
            lastPage: response.pagination.last_page,
            perPage: response.pagination.per_page,
            total: response.pagination.total,
            links: {
                next: response.pagination.links.next,
                prev: response.pagination.links.prev,
            },
        },
    };
}